module.exports = __webpack_public_path__ + "static/media/ic_fan-dashboard-new.fa2d4901.png";